import {
  ADD_TEAM,
  ADD_TEAM_FAILURE,
  ADD_TEAM_SUCCESS,
  //
  DELETE_TEAM,
  DELETE_TEAM_FAILURE,
  DELETE_TEAM_SUCCESS,
  //
  EDIT_TEAM,
  EDIT_TEAM_FAILURE,
  EDIT_TEAM_SUCCESS,
  //
  FETCH_TEAMS,
  FETCH_TEAMS_FAILURE,
  FETCH_TEAMS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_TEAM_ADD_MODAL,
  //
  SEARCH_TEAMS,
  SEARCH_TEAMS_SUCCESS,
  SEARCH_TEAMS_FAILURE,
} from "./constants";

// List
export const fetchTeams = (payload) => ({
  type: FETCH_TEAMS,
  payload,
});
export const fetchTeamsSuccess = (payload) => ({
  type: FETCH_TEAMS_SUCCESS,
  payload,
});
export const fetchTeamsFailure = (payload) => ({
  type: FETCH_TEAMS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addTeam = (payload, onSuccess) => ({
  type: ADD_TEAM,
  payload,
  onSuccess,
});
export const addTeamSuccess = (payload) => ({
  type: ADD_TEAM_SUCCESS,
  payload,
});
export const addTeamFailure = (payload) => ({
  type: ADD_TEAM_FAILURE,
  payload,
});
// EDIT
export const editTeam = (payload, onSuccess) => ({
  type: EDIT_TEAM,
  payload,
  onSuccess,
});
export const editTeamSuccess = (payload) => ({
  type: EDIT_TEAM_SUCCESS,
  payload,
});
export const editTeamFailure = (payload) => ({
  type: EDIT_TEAM_FAILURE,
  payload,
});
// DELETE
export const deleteTeam = (payload, onDelete) => ({
  type: DELETE_TEAM,
  payload,
  onDelete,
});
export const deleteTeamSuccess = (payload) => ({
  type: DELETE_TEAM_SUCCESS,
  payload,
});
export const deleteTeamFailure = (payload) => ({
  type: DELETE_TEAM_FAILURE,
  payload,
});

export const toggleTeamAddModal = (payload) => ({
  type: TOGGLE_TEAM_ADD_MODAL,
  payload,
});

//
export const searchTeams = (payload) => ({
  type: SEARCH_TEAMS,
  payload,
});
export const searchTeamsSuccess = (payload) => ({
  type: SEARCH_TEAMS_SUCCESS,
  payload,
});
export const searchTeamsFailure = (payload) => ({
  type: SEARCH_TEAMS_FAILURE,
  payload,
});
